export function SubscriptionCancelled() {
  return (
    <div class="subscription-result-page cancelled">
      <div class="result-container">
        <div class="result-icon cancelled">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>

        <h1>Checkout Cancelled</h1>

        <p class="result-message">
          Your checkout was cancelled. No charges were made.
        </p>

        <p class="result-details">
          If you experienced any issues or have questions about our plans,
          please don't hesitate to contact us.
        </p>

        <div class="result-actions">
          <a href="/upgrade" class="btn btn-primary">
            View Plans
          </a>
          <a href="/" class="btn btn-secondary">
            Back to Dashboard
          </a>
        </div>

        <p class="result-note">
          Need help? Contact us at{' '}
          <a href="mailto:support@maltashopper.com">support@maltashopper.com</a>
        </p>
      </div>
      <style>{styles}</style>
    </div>
  );
}

const styles = `
  .subscription-result-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
    padding: 2rem;
  }

  .subscription-result-page.cancelled {
    background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  }

  .result-container {
    background: white;
    border-radius: 12px;
    padding: 3rem;
    max-width: 480px;
    width: 100%;
    text-align: center;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  }

  .result-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 1.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .result-icon.cancelled {
    background: #fef3c7;
    color: #d97706;
  }

  .result-icon svg {
    width: 40px;
    height: 40px;
  }

  .subscription-result-page h1 {
    font-size: 1.75rem;
    color: #1e293b;
    margin-bottom: 1rem;
  }

  .result-message {
    font-size: 1.125rem;
    color: #64748b;
    margin-bottom: 1rem;
  }

  .result-details {
    color: #94a3b8;
    margin-bottom: 2rem;
  }

  .result-actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;
  }

  .btn {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    border: none;
    font-size: 1rem;
  }

  .btn-primary {
    background: #3b82f6;
    color: white;
  }

  .btn-primary:hover {
    background: #2563eb;
  }

  .btn-secondary {
    background: #f1f5f9;
    color: #475569;
  }

  .btn-secondary:hover {
    background: #e2e8f0;
  }

  .result-note {
    font-size: 0.875rem;
    color: #94a3b8;
  }

  .result-note a {
    color: #3b82f6;
  }
`;
